import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { useSelector } from "react-redux";

const useOrderConfirmationCart = () => {
    return useSelector((state: ApplicationState) => {
        return getCartState(state, state.pages.orderConfirmation.cartId).value;
    });
};

export default useOrderConfirmationCart;
